'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useVersionCheck } from '~/hooks/useVersionCheck';
import { Button } from '~/components/ui/button';
import { Text } from '~/components/ui/text';
import { Card, CardContent, CardHeader, CardTitle } from '~/components/ui/card';
import { RefreshCw } from 'lucide-react';
export const VersionUpdatePopup = () => {
  const $ = _c(14);
  const {
    shouldShowPopup,
    dismissPopup,
    refreshApp
  } = useVersionCheck();
  if (!shouldShowPopup) {
    return null;
  }
  const t0 = `fixed inset-0 z-50 ${shouldShowPopup ? "block" : "hidden"}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CardHeader className="pb-3"><CardTitle className="flex flex-row items-center gap-2"><Text variant="title" size="lg">Update Available</Text></CardTitle></CardHeader>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text className="text-sm text-gray-600 dark:text-gray-300">A new version is available. Refresh to get the latest updates.</Text>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-row items-center justify-center gap-2"><RefreshCw size={16} className="text-white" /><Text className="text-white font-medium">Refresh</Text></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== refreshApp) {
    t4 = <Button onClick={refreshApp} className="flex-1" variant="default">{t3}</Button>;
    $[3] = refreshApp;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text className="font-medium">Later</Text>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== dismissPopup) {
    t6 = <Button onClick={dismissPopup} variant="ghost" className="flex-1">{t5}</Button>;
    $[6] = dismissPopup;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t6) {
    t7 = <div className="flex-1 bg-black/50 justify-end items-end px-4 min-h-screen"><Card className="w-full max-w-sm mx-auto bg-white dark:bg-gray-800">{t1}<CardContent className="space-y-4">{t2}<div className="flex flex-row gap-3">{t4}{t6}</div></CardContent></Card></div>;
    $[8] = t4;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t0 || $[12] !== t7) {
    t8 = <div className={t0}>{t7}</div>;
    $[11] = t0;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};